<div class="card">
  <div class="body p-0">
    <div class="table-responsive">
      <p-table #d1 [value]="data" [alwaysShowPaginator]="false" [lazy]="tableConfig?.isLazy || false"
        [paginator]="!tableConfig?.noPagination" (onLazyLoad)="loadData($event)" [rows]="defaultRow" [autoLayout]="true"
        [totalRecords]="totalRecords" [globalFilterFields]="cols" [resizableColumns]="true" [first]="first"
        columnResizeMode="expand" [globalFilterFields]="globalFilterField" [responsive]="true"
        tableStyleClass="table  width-full">

        <ng-template pTemplate="caption">
          <div class="d-flex flex-row justify-content-end">
            @if (tableConfig?.globalFilter) {
            <div class="form-group p-2 flex-grow-">
              <input class="form-control" placeholder="Search.." pInputText type="text"
                (input)="d1.filterGlobal($any($event.target).value, 'contains')">
            </div>
            }
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th>S/No.</th>
            @for (col of cols; track col; let i = $index) {
            @if (col.sort) {
            <th [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
            </th>
            } @else {
            <th> {{col.header}}</th>
            }
            }
            @if (actionBtn?.length) {
            <th>Actions
              <p-button [disabled]="tableLoader" size="small" severity="warn" (click)="reload()" [raised]="true"
                class="me-1" title="Reload Table"
                [icon]="'pi ' + (tableLoader ? 'pi-spin pi-spinner':'pi-refresh' )"></p-button>
              @if (tableConfig?.addBtn) {
              <p-button [disabled]="tableLoader" size="small" (click)="btnAction('','ADD')" [raised]="true" class="me-1"
                title="Add New" [icon]="'pi ' + (tableLoader ? 'pi-spin pi-spinner':'pi-plus' )"></p-button>
              }
              @if (tableConfig?.exportBtn) {
              <p-button [disabled]="tableLoader" severity="success" size="small" (click)="btnAction('','EXPORT')"
                class="me-1" [raised]="true" title="Export"
                [icon]="'pi ' + (tableLoader ? 'pi-spin pi-spinner':'pi-file-excel' )"></p-button>
              }
            </th>
            }
          </tr>
          @if (tableConfig?.showFilter) {
          <tr>
            <th></th>
            @for (c of cols; track c) {
            @if (c?.filter === true) {
            <th>
              @if (c?.filterCol?.type == 'TEXT' || !c?.filterCol?.type) {
              <p-columnFilter type="text" placeholder="search" matchMode="contains" [showMenu]="false"
                [field]="c?.field"></p-columnFilter>
              }
              @if (c?.filterCol?.type == 'DROPDOWN') {
              <p-columnFilter [field]="c?.colName" matchMode="equals" [showMenu]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown [autoOptionFocus]="false" [ngModel]="value" [appendTo]="'body'" [style]="{'width':'100%' ,'padding' : '0'}"
                    [filter]="FORM_SUPPORT_DATA[c?.colName]?.length > 15 ? true : false"
                    (onChange)="filter($event.value)" [options]="FORM_SUPPORT_DATA[c?.colName]"
                    [optionValue]="c?.filterCol?.selectPrimaryKey ||  'key'"
                    [placeholder]="c?.filterCol?.placeholder || 'Any'"
                    [optionLabel]="c?.filterCol?.selectKeyName || 'label'" [showClear]="true">
                    <ng-template let-option pTemplate="item">
                      @if (DATA_LOADING[c?.colName]) {
                      <span class="customer-badge status">{{ 'loading...' }}</span>
                      }
                      <span class="customer-badge status">{{option[c?.filterCol?.selectKeyName
                        || 'label']}}</span>
                    </ng-template>
                  </p-dropdown>
                </ng-template>
              </p-columnFilter>
              }
              @if (c?.filterCol?.type == 'DATE') {
              <p-columnFilter [field]="c?.field" matchMode="equals" [showMenu]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-calendar [readonlyInput]="true" dateFormat="dd/mm/yy" [showButtonBar]="true" appendTo="body"
                    [view]="c?.filterCol?.dateViewMode || 'date'" (onSelect)="filter($event)"
                    (onClearClick)="filter($event)" [maxDate]="c?.filterCol?.maxDate"
                    [monthNavigator]="c?.filterCol?.monthNavigator ?true : false"
                    [yearNavigator]="c?.filterCol?.yearNavigator ? true : false" [minDate]="c?.filterCol?.minDate"
                    [yearRange]="c?.filterCol?.yearRange || yearRange"
                    [placeholder]="c?.filterCol?.placeholder || 'Any'">
                  </p-calendar>
                </ng-template>
              </p-columnFilter>
              }
            </th>
            } @else {
            <th></th>
            }
            }
            <th></th>
          </tr>
          }
          @if (tableLoader) {
          <tr>
            <td [attr.colspan]="cols.length" class="text-center"><i class="pi pi-spin pi-spinner"></i>Please
              wait data fetching...</td>
          </tr>
          }
        </ng-template>
        <ng-template pTemplate="emptymessage">
          @if (!tableLoader) {
          <tr>
            <td [attr.colspan]="cols.length + 1" class="text-center">No data found.</td>
          </tr>}
        </ng-template>
        <ng-template pTemplate="body" let-request let-i="rowIndex">
          <tr (click)="onSelectData(request)"
            [ngClass]="{'bg-primary text-light selectedRow' : request.selectable,'cursor-pointer' : request.selectable}"
            class="{{request.selectable ? 'cursor-pointer bg-primary text-light' : request.classList ? request.classList : '' }}">
            <td>{{i + 1}}</td>

            @for (col of cols; track col; let i = $index) {
            @if (!col?.isEditable) {
            @switch (col?.type) {
            @case ('IMAGE') {
            <td>
              <img imageLoad [src]="request[col.field]" alt="Document" class="rounded-circle avatar-sm">
            </td>
            }
            @case ('DATE') {
            <td>
              <h5 class="m-0 fw-normal">{{request[col.field] |
                date:'dd-MMM-yyyy'}}</h5>
            </td>
            }
            @case ('CURRENCY') {
            <td>
              <h5 class="m-0 fw-normal"> {{request[col.field] | currencyFormat}}</h5>
            </td>
            }
            @case ('STATUS') {
            <td>
              <span class="badge"
                [ngClass]="{'badge-success' : +request[col.field]==1 , 'badge-danger' : +request[col.field] ==0, 'badge-warning' : +request[col.field] == 2 }">{{statusArray[request[col.field]]}}</span>
            </td>
            }
            @case ('DROPDOWN') {
            <td>
              @for (m of FORM_SUPPORT_DATA[col?.colName]; track m) {
              @if (m[col?.filterCol?.selectPrimaryKey || 'key'] == request[col.colName]) {
              @if (m?.color) {
              <span class="badge bg-{{m?.color || 'info'}}">{{
                m[col?.filterCol?.selectKeyName || 'label']}}</span>
              } @else {
              {{ m[col?.filterCol?.selectKeyName || 'label']}}
              }
              }
              }
            </td>
            }
            @case ('STAFF_EMP_ID') {
            <td>
              @for (f of request[col.field] | transformArray:',':' & '; track f) {
              <strong><a class="link" title="Staff Info" (click)="openStaffInfo(f)"
                  href="javascript:void(0)">{{f}}</a></strong>
              }
            </td>
            }
            @case ('STUDENT_ID') {
            <td>
              <strong>
                <a class="link" title="Student Info" (click)="openStudentInfo(request.student_fk_id)"
                  href="javascript:void(0)">
                  {{request.student_code}}
                </a>
              </strong>
            </td>
            }
            @case ('STAFF_ID') {
            <td>
              <strong>
                <a class="link" title="Staff Info" (click)="openStaffInfo(request.id)" href="javascript:void(0)">
                  {{request.staff_emp_id}}
                </a>
              </strong>
            </td>
            }
            @case ('VIEW_INFO') {
            <td>
              @for (f of request[col.field] | transformArray:',':' & '; track f) {
              <strong><a class="link" title="View Info" (click)="btnAnchorAction(f,request)" href="javascript:void(0)"
                  [innerHTML]="f |safeHtml"></a></strong>
              }
            </td>
            }
            @case ('VIEW_TAG_INFO') {
            <td class="cursor-pointer">
              @for (f of request[col.field]; track f) {
              <div (click)="btnTagInfo(f,request)" [innerHTML]="f?.text |safeHtml"></div>
              }
            </td>
            }
            @default {
            <td>
              @if (col?.icon_append?.text && request[col.field] ) {
              <span [innerHTML]="request[col.field] + ' ' +col?.icon_append?.text || '' | safeHtml"></span>
              } @else {
              <!-- @if text conatine html  -->
              <!-- @if(request[col.field].includes('</')){
                 <div [innerHTML]="request[col.field] || '' | safeHtml">
    </div>
    }
    @else{ -->

              <h5 class="m-0 fw-normal" [innerHTML]="request[col.field] || '' | safeHtml"></h5>
              <!-- } -->
              }
              <ng-template #noAppend><span [innerHTML]="request[col.field] || '' | safeHtml"></span></ng-template>
            </td>
            }
            }
            } @else {
            <td pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" (keydown.enter)="updateRow(request,col?.field,request[col.field])"
                    (change)="updateRow(request,col?.field,request[col.field])" class="w-100"
                    [(ngModel)]="request[col.field]" required>
                </ng-template>
                <ng-template pTemplate="output">
                  <span>{{request[col.field]}}</span>
                </ng-template>
              </p-cellEditor>
            </td>
            }
            <ng-template #isEditable>
              <td pEditableColumn>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText type="text" (keydown.enter)="updateRow(request,col?.field,request[col.field])"
                      (change)="updateRow(request,col?.field,request[col.field])" class="w-100"
                      [(ngModel)]="request[col.field]" required>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span>{{request[col.field]}}</span>
                  </ng-template>
                </p-cellEditor>
              </td>
            </ng-template>
            }

            @if (actionBtn?.length && makeChange) {
            <td>
              @for (b of actionBtn; track b) {
              @switch (b?.category) {
              @case ('TEXT') {
              @if (!b.condition || (b.condition && (request | conditionOperator : b.condition))) {
              <span>{{b.name}}</span>
              }
              }
              @default {
              @if (!b.condition || (b.condition && (request | conditionOperator : b.condition))) {
              <!-- <button class="btn btn-sm ms-1 {{b.class || ''}}" [class.btn-default]="!b.class"
                [title]="b?.title | titlecase"
                (click)="$event.stopPropagation();btnAction(request[primaryKey] || '', b?.type,request)"><i
                  class="{{b.iconClass || ''}} {{b.icon}}"></i></button> -->
              <p-button icon="{{b.icon}}" [text]="!b?.severity || b?.btnTextStyle ||false " [raised]="true" size="small"
                class="{{b.class || ''}} me-1" [title]="b?.title | titlecase" [severity]="b?.severity "
                [disabled]="btnLoader[request[primaryKey]+b?.type]" [loading]="btnLoader[request[primaryKey]+b?.type]"
                (click)="$event.stopPropagation();btnAction(request[primaryKey] || '', b?.type,request)"></p-button>
              }
              }
              }
              }
            </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
          Total Request {{ state.first ? state.first+1 :1}} -
          {{ (state.first+state.rows) > state.totalRecords ?
          state.totalRecords : state.rows+state.first }}
          of {{state.totalRecords}}
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<ng-template #rowTable let request let-col>
  <td>

  </td>
</ng-template>